// Description: Policy Editor functionality.
//
//TODO: Refactor to use ES6 syntax and functions.

function setupPolicyEditor() {
    const elementFields = document.querySelectorAll(".js-policy-element");
    elementFields.forEach(addPolicyElementEventListeners);
}

function editorLoad(editor) {
    let contentAreaEl = editor.get_contentAreaElement();
    contentAreaEl.removeAttribute("title");
    fixRadEditorHeight(editor);
    editor.get_toolContainer().parentElement.style.height = '5px';
}

function addPolicyElementEventListeners(element) {
    let policyRadEditorFields = element.querySelectorAll(".js-policy-text-section");
    let policyReplacerTags = element.querySelectorAll(".replacer-tag");
    element.addEventListener('mouseover', event => {
        toggleElementHover(element, true);
    });
    element.addEventListener('mouseout', event => {
        toggleElementHover(element, false);
    });
    element.addEventListener('click', event => {
        toggleElementFocus(element, true);
    });
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(element);
        if (withinBoundaries) {
            toggleElementFocus(element, true);
        } else {
            toggleElementFocus(element, false);
        }
    });
    policyRadEditorFields.forEach(policyRadEditorField => policyRadEditorField.addEventListener('click', event => {
        if (document.activeElement === policyRadEditorField.querySelector('.reContentArea')) {
            toggleElementFocus(element, true);
        }
    }));
    policyRadEditorFields.forEach(policyRadEditorField => {
        addPolicyDragDropEvents(policyRadEditorField);
    });
    policyReplacerTags.forEach(policyReplacerTag => {
        //policyReplacerTag.onselectstart = preventTextSelect;
        addPolicyReplacerEvents(policyReplacerTag);
    });
}

function addPolicyRadEditorEvents(editor, args) {
    let element = editor.get_contentArea();
    let childElements = element.getElementsByTagName('p');
    addPolicyDragDropEvents(element);
    childElements.forEach(addPolicyDragDropEvents(element));
}

function addPolicyReplacerEvents(element) {
    //element.removeEventListener('mousedown', preventTextSelect);
    //element.addEventListener('mousedown', preventTextSelect);
    //element.removeEventListener('mouseup', preventTextSelect);
    //element.addEventListener('mouseup', preventTextSelect);
    // TODO - fix below for replacer tag drag and drop
    element.removeEventListener('dragstart', dragStart);
    element.addEventListener('dragstart', dragStart);
    element.dataset.action === 'move'
    //element.addEventListener('dragenter', dragEnter)
    //element.addEventListener('dragover', dragOver);
    //element.addEventListener('dragleave', dragLeave);
    //element.addEventListener('drop', dropMove);
}

function addPolicyDragDropEvents(element) {
    //element.removeEventListener('mousedown', preventTextSelect);
    //element.addEventListener('mousedown', preventTextSelect);
    element.removeEventListener('dragenter', dragEnter)
    element.removeEventListener('dragover', dragOver);
    element.removeEventListener('dragleave', dragLeave);
    element.removeEventListener('drop', drop);
    element.removeEventListener('allowDrop', allowDrop);

    element.addEventListener('dragenter', dragEnter)
    element.addEventListener('dragover', dragOver);
    element.addEventListener('dragleave', dragLeave);
    element.addEventListener('drop', drop);
    element.addEventListener('allowDrop', allowDrop);
}

const dragDepo = {}; //User to pass the object reference of the dragged element from dragStart to drop since dataTransfer only allows string data. This is a workaround to avoid using global variables for storing the dragged element reference.

//function preventTextSelect() {
//    return false;
//}

//function renderReplacerTag(node) {
//    const textNode = document.createTextNode('Some Text');
//    const tagSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//    const tagPath = document.createElementNS(
//        'http://www.w3.org/2000/svg',
//        'text'
//    );
//    tagSvg.setAttribute('height', '30');
//    tagSvg.setAttribute('width', '200');
//    tagPath.setAttribute('x', '30');
//    tagPath.setAttribute('y', '30');
//    tagPath.setAttribute('fill', 'black');
//    tagPath.appendChild(textNode);

//    tagSvg.appendChild(tagPath);

//    return node.appendChild(tagSvg);
//}

function allowDrop(e) {
    e.preventDefault();
}
function dragStart(e) {
    const action = e.target.dataset.action;
    e.dataTransfer.setData('text/html', e.target.outerHTML);
    e.dataTransfer.setData('tagAction', action);
    var target = e.target;

    const dragID = Date.now().toString();
    dragDepo[dragID] = target; // Store the actual node reference
    e.dataTransfer.setData('draggedElement', dragID);
    //var selection = e.target;
    console.log('start->drag->' + action);
    //e.target.contentEditable = true;
    //selection.setAttribute("contenteditable", false);
    //document.addEventListener('drop', (e) => { drop(e, selection, action) }, { once: true });
}

function drop(e) {
    const dragID = e.dataTransfer.getData("draggedElement");
    var draggedElement = dragDepo[dragID];
    delete dragDepo[dragID];
    const action = e.dataTransfer.getData("tagAction");

    if (action === 'copy') {
        draggedElement = draggedElement.cloneNode(true);
        draggedElement.dataset.action = 'move';
    }

    console.log('end->drag->' + action);
    e.preventDefault();

    let range;

    if (document.caretPositionFromPoint) {
        // Standard modern approach
        const pos = document.caretPositionFromPoint(e.clientX, e.clientY);
        range = document.createRange();
        range.setStart(pos.offsetNode, pos.offset);
        range.collapse(true);

    } else if (document.caretRangeFromPoint) {
        // Legacy WebKit fallback (still exists in many browsers for now)
        range = document.caretRangeFromPoint(e.clientX, e.clientY);

    } else if (e.rangeParent) {
        // Firefox
        range = document.createRange();
        range.setStart(e.rangeParent, e.rangeOffset);

    }

    if (range) { range.insertNode(draggedElement); }
    else { e.target.appendChild(draggedElement); }


    //e.target.addEventListener('dragstart', dragStart);

}

function deleteTag(e) {
    e.preventDefault();
    const action = e.dataTransfer.getData("tagAction");
    if (action === 'copy') { return }

    const dragID = e.dataTransfer.getData("draggedElement");
    const draggedElement = dragDepo[dragID];
    delete dragDepo[dragID];

    if (draggedElement) {
        draggedElement.remove(); // Deletes the tag from the page
        console.log("Tag removed successfully");
    }
}

//function dropOld(e) {
//    //e.preventDefault();
//    //var tagAction = e.dataTransfer.getData("tagAction");
//    //var tag = e.dataTransfer.getData("text/html");
//    //var tagSrc = e.dataTransfer.getData("tagSrc");
//    if (tagAction === 'move') {
//        console.log('drop->Move');
//        //var tagSrc = e.dataTransfer.getData("tagSrc");
//        //tagSrc.outerHTML = '';
//    }
//    else {
//        console.log('drop->Copy');
//        tag = tag.replace('data-action="copy"', 'data-action="move"');
//    }
//    //e.target.insertAdjacentHTML('beforebegin', tag);
//    //e.target.insertNode(tagSrc);
//    //addPolicyReplacerEvents(tagSrc);

//    //}
//    //setupPolicyEditor();
//    //let policyReplacerTags = document.querySelectorAll(".policy-content .replacer-tag");
//    //policyReplacerTags.forEach(policyReplacerTag => {
//    //    policyReplacerTag.onselectstart = preventTextSelect;
//    //    addPolicyReplacerEvents(policyReplacerTag);
//    //});
//}

function dragEnter(e) {
    e.preventDefault();
    e.target.classList.add('drag-over');
}

function dragOver(e) {
    e.target.classList.add('drag-over');
}

function dragLeave(e) {
    e.target.classList.remove('drag-over');
}

//function pasteHtmlAtCaret(html) {
//    console.log('pasteHtmlAtCaret');

//    var sel, range;
//    if (window.getSelection) {
//        sel = window.getSelection();
//        if (sel.getRangeAt && sel.rangeCount) {
//            range = sel.getRangeAt(0);
//            range.deleteContents();
//            range.insertNode(document.createTextNode(text));
//        }
//    } else if (document.selection && document.selection.createRange) {
//        document.selection.createRange().text = text;
//    }
//}


//  var insertTokenAt = input.prop("selectionEnd");
//   var nextSelectionEnd = (insertTokenAt + insertToken.length);
//input.val(
//      inputValue.slice(0, insertTokenAt) +
//      insertToken +
//      inputValue.slice(insertTokenAt)
//  );

//  // Advance the text selection to just after the inserted text.
//  input
//      .prop("selectionStart", nextSelectionEnd)
//      .prop("selectionEnd", nextSelectionEnd)
//      .focus()
//      ;



/*document.selection.createRange().pasteHTML(html);*/
//let sel, range;
//sel = window.getSelection();
//if (sel.getRangeAt && sel.rangeCount) {
//    range = sel.getRangeAt(0);
//    let frag = document.createDocumentFragment();
//    frag.innerHTML = html;
//    range.insertNode(frag);
//}
//addPolicyReplacerEvents(el);
/*}*/